import { render, staticRenderFns } from "./Expenses.vue?vue&type=template&id=393f222b&scoped=true&lang=pug"
import script from "./Expenses.vue?vue&type=script&lang=js"
export * from "./Expenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393f222b",
  null
  
)

export default component.exports